import {Component, OnInit, TemplateRef} from '@angular/core';
// import { BsLocaleService, BsModalRef, BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { FilterService } from '../../services/filter/filter.service';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PanelConfigurationIndicators } from '../../model/configuration/panelConfigurationIndicators.model';
import { PanelConfigurationIndicatorsResult } from '../../model/configuration/panelConfigurationIndicatorsResult.model';
import { forkJoin } from 'rxjs';
import { BusinessProcessDimensionListResult } from '../../model/filter/businessProcesseListResult.model';
import { BusinessProcessDimension } from '../../model/configuration/businessProcessDimension.model';
import { StateDimension, StateDimensionListResult } from '../../model/configuration/stateDimension.model';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {GenericModalService} from '../../services/utils/generic-modal.service';

@Component({
  selector: 'app-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.css']
})
export class GoalsComponent implements OnInit {

  listGoals: Array<PanelConfigurationIndicators>;
  selectedGoal: PanelConfigurationIndicators;
  isSaving: boolean;
  successfullySaved: boolean;
  isLoading: boolean;

  textAction: string;
  isEdit: boolean;

  businessProcessList: Array<BusinessProcessDimension> = [];
  filteredStates: Array<StateDimension> = [];

  BusinessProcess: BusinessProcessDimension;
  State: StateDimension;

  errorState = false;
  errorStateMessage: string;

  errorBP = false;
  errorBPMessage: string;

  errorSLA = false;
  errorSLAMessage: string;

  errorTolerance = false;
  errorToleranceMessage: string;

  errorTMA = false;
  errorTmaMessage: string;

  errorTME = false;
  errorTmeMessage: string;

  errorTMO = false;
  errorTmoMessage: string;

  constructor(private filterService: FilterService,
              private configurationService: ConfigurationService,
              private fb: FormBuilder,
              private toastr: ToastrService,
              private localeService: BsLocaleService,
              public bsModalRef: BsModalRef,
              public genericModalService: GenericModalService) {

    this.isLoading = false;

    this.selectedGoal = new PanelConfigurationIndicators();
    this.listPanelConfigurationIndicators();
    localeService.use('pt-br');
  }

  // Reactive forms
  businessProcessCtrl = new FormControl();
  stateCtrl = new FormControl();

  formBusinessProcess = new FormGroup({
    businessProcessList: this.businessProcessCtrl
  });

  formState = new FormGroup({
    stateList: this.stateCtrl
  });


  ngOnInit() {
    this.getBusinessProcess();
  }

  public getBusinessProcess() {
    const getBusinessProcessCall = this.filterService.getBusinessProcess();

    forkJoin([getBusinessProcessCall]).subscribe(results => {
      const resultBPs: BusinessProcessDimensionListResult = results[0] as BusinessProcessDimensionListResult;
      if (resultBPs.result) {

        this.businessProcessList = resultBPs.result;
      }

    });
  }

  onSelectBP(event: TypeaheadMatch): void {

    this.BusinessProcess = event.item;
    this.selectedGoal.businessProcessDimension = this.BusinessProcess;
  }

  onSelectState(event: TypeaheadMatch): void {

    this.State = event.item;
    this.selectedGoal.stateDimension = this.State;
  }

  onChangeBusinessProcess(event: TypeaheadMatch): void {

    if (event.item !== undefined) {

      this.filterService.getStates(event.item.businessProcessId).subscribe((resp: StateDimensionListResult) => {

        if (resp.result) {

          this.filteredStates = resp.result;
        }
      });
    }
  }

  onClickNew(staticModel: TemplateRef<any>)  {

    this.textAction = 'Nova';
    this.isEdit = false;
    this.reloadValidation();
    this.selectedGoal = new PanelConfigurationIndicators;
    this.successfullySaved = false;
    // this.modalRef = staticModel;
    // staticModel.show();
    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {}, 'modal-xl');
  }

  onClickEdit(content, staticModel: TemplateRef<any>) {

    this.textAction = 'Editar';
    this.isEdit = true;
    this.reloadValidation();
    this.selectedGoal = Object.assign({}, content);
    // this.modalRef = staticModel;
    this.successfullySaved = false;
    // staticModel.show();
    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {}, 'modal-xl');
  }

  onClickDelete(content: PanelConfigurationIndicators) {
    this.selectedGoal = Object.assign({}, content);
  }

  getDateTimeFormat() {

    const day = `0${new Date().getUTCDate() + 1}`.slice(-2);
    const month = `0${new Date().getUTCMonth() + 1}`.slice(-2);
    const year = new Date().getUTCFullYear();

    const formatedTo = this.getFormatMask('XX:XX:XX', this.selectedGoal.fomatedTO);
    const formatedTa = this.getFormatMask('XX:XX:XX', this.selectedGoal.fomatedTA);
    const formatedTe = this.getFormatMask('XX:XX:XX', this.selectedGoal.fomatedTE);

    this.selectedGoal.to = this.getNowUTC(new Date(`${year}-${month}-${day}T${formatedTo}Z`));
    this.selectedGoal.ta = this.getNowUTC(new Date(`${year}-${month}-${day}T${formatedTa}Z`));
    this.selectedGoal.te = this.getNowUTC(new Date(`${year}-${month}-${day}T${formatedTe}Z`));
  }

  private getNowUTC(dateNow: Date): Date {
    return new Date(dateNow.getTime() + (dateNow.getTimezoneOffset() * 60000));
  }

  private getFormatMask(mask, value: string) {

    let result = '';

    for (let im = 0, is = 0; im < mask.length && is < value.length; im++) {
      result += mask.charAt(im) === 'X' ? value.charAt(is++) : mask.charAt(im);
    }
    return result;
  }

  onClickSaveGoals() {

    if (this.fieldValidation()) {
      return;
    }
    this.getDateTimeFormat();

    this.isSaving = true;

    this.configurationService.savePanelConfigurationIndicators(this.selectedGoal)
      .subscribe(
        (resp: any) => {
          if (resp.result) {
            this.successfullySaved = true;
            this.toastr.success('Configuração de metas salva com sucesso!', 'Sucesso', { positionClass: 'toast-top-center' });
            this.isSaving = false;
            this.onCloseModal();
            this.listPanelConfigurationIndicators();
          } else if (resp.error) {
            this.successfullySaved = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
          }
          this.isSaving = false;
        }
      );
  }

  listPanelConfigurationIndicators(): void {
    this.isLoading = true;
    this.listGoals = [];

    this.configurationService.listPanelConfigurationIndicators().subscribe(async (resp: PanelConfigurationIndicatorsResult) => {

      if (resp.result) {

        this.listGoals = resp.result;
      } else if (resp.error) {

        this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
      }
      this.isLoading = false;
    });
  }

  reloadValidation() {
    this.errorBP = false;
    this.errorState = false;
    this.errorSLA = false;
    this.errorTolerance = false;
    this.errorTMO = false;
    this.errorTMA = false;
    this.errorTME = false;
  }

  fieldValidation() {

    var isError = false;

    if (this.selectedGoal.businessProcessDimension.id == undefined) {
      this.errorBP = true;
      this.errorBPMessage = 'Informar o Processo de Negócio';
      isError = true;
    }

    if (this.selectedGoal.stateDimension.id == undefined) {
      this.errorState = true;
      this.errorStateMessage = 'Informar o Estado';
      isError =  true;
    }

    if (this.selectedGoal.sla == undefined) {
      this.errorSLA = true;
      this.errorSLAMessage = 'Informar um valor de Meta';
      isError = true;
    }

    if (this.selectedGoal.toleranceInterval == undefined) {
      this.errorTolerance = true;
      this.errorToleranceMessage = 'Informar um valor de Tolerância';
      isError = true;
    }

    if (this.selectedGoal.fomatedTO === undefined || this.selectedGoal.fomatedTO.length !== 6) {
      this.errorTMO = true;
      this.errorTmoMessage = 'Campo inválido';
      isError = true;
    }

    if (this.selectedGoal.fomatedTA === undefined || this.selectedGoal.fomatedTA.length !== 6) {
      this.errorTMA = true;
      this.errorTmaMessage = 'Campo inválido';
      isError = true;
    }

    if (this.selectedGoal.fomatedTE === undefined || this.selectedGoal.fomatedTE.length !== 6) {
      this.errorTME = true;
      this.errorTmeMessage = 'Campo inválido';
      isError = true;
    }

    return isError;
  }

  isValidForm() {

    return this.selectedGoal.businessProcessDimension.businessProcessId !== undefined
      && this.selectedGoal.stateDimension.stateId !== undefined
      && this.selectedGoal.sla !== undefined
      && this.selectedGoal.toleranceInterval !== undefined
      && this.selectedGoal.fomatedTO.length === 6
      && this.selectedGoal.fomatedTA.length === 6
      && this.selectedGoal.fomatedTE.length === 6;
  }

  removeBPListSelected() {
    this.errorBP = false;
    this.BusinessProcess = new BusinessProcessDimension();
    this.selectedGoal.businessProcessDimension = this.BusinessProcess;
    this.removeStateListSelected();
  }

  removeStateListSelected() {
    this.errorState = false;
    this.State = new StateDimension();
    this.selectedGoal.stateDimension = this.State;
  }

  typeaheadNoResultsState(event: boolean): void {
    this.errorState = event;
    this.errorStateMessage = 'Nenhum resultado encontrado';
  }

  typeaheadNoResultsBP(event: boolean): void {
    this.errorBP = event;
    this.errorBPMessage = 'Nenhum resultado encontrado';

    this.removeStateListSelected();
  }

  onClickConfirmDelete() {
    this.configurationService.deletePanelConfigurationIndicators(this.selectedGoal.id).subscribe((resp: any) => {
      this.toastr.success('Configuração de meta: ' + this.selectedGoal.businessProcessDimension.name +
        ' excluído com sucesso!', 'Sucesso', { positionClass: 'toast-top-center' });
      this.listPanelConfigurationIndicators();
    });
  }

  onCloseModal() {
    this.bsModalRef.hide();
  }

}
